import React, { FC } from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { NeltifyImage } from '../../cms/NetlifyImage';

interface Props {
  image?: {
    readonly childImageSharp: {
      readonly gatsbyImageData: IGatsbyImageData;
    } | null;
  } | null;
  alt?: string | null;
  [s: string]: unknown;
}

const Image: FC<Props | { image: string; alt: string }> = ({
  image,
  alt,
  ...rest
}) => {
  if (!image || !alt) return null;

  if (typeof image === 'string') {
    return <NeltifyImage src={image} alt={alt} {...rest} />;
  }

  if (!image?.childImageSharp?.gatsbyImageData) return null;

  return (
    <GatsbyImage
      image={image.childImageSharp.gatsbyImageData}
      alt={alt}
      {...rest}
    />
  );
};

export default Image;
